/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityVulnerabilityValidationForOCIResponse {
    getFixupPrototypeFunction() { return SecurityVulnerabilityValidationForOCIResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityVulnerabilityValidationForOCIResponse>): SecurityVulnerabilityValidationForOCIResponse {
        let obj = Object.assign(new SecurityVulnerabilityValidationForOCIResponse(), model);
        SecurityVulnerabilityValidationForOCIResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityVulnerabilityValidationForOCIResponse>): SecurityVulnerabilityValidationForOCIResponse {
        if (!model) return null;
        return SecurityVulnerabilityValidationForOCIResponse.newInstance(<SecurityVulnerabilityValidationForOCIResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityVulnerabilityValidationForOCIResponse) {
        if (!obj) return;

        models.SecurityVulnerabilityValidationForOCIResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityVulnerabilityValidationForOCIResponse): boolean {
        Object.setPrototypeOf(obj, SecurityVulnerabilityValidationForOCIResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * If set, Host Scan Target is enabled.
     */
    host_scan_target: boolean;

}
